import { Close } from "@mui/icons-material";
import { Box, IconButton, Modal } from "@mui/material";
import React from "react";

const ImageViwer = ({ open, setOpen, src }) => {
  return (
    <Modal open={open || false} onClose={() => setOpen(false)}>
      <Box className="absolute shadow flex top-1/2 left-1/2 -translate-y-1/2 outline-none -translate-x-1/2 bg-white dark:!bg-zinc-800 p-5 rounded w-10/12 lg:w-auto h-fit lg:h-auto">
        <img src={src} alt="" className="rounded" />
        <span className="w-0 relative bottom-5 right-5">
          <IconButton
            onClick={() => setOpen(false)}
            className="!bg-white dark:!bg-zinc-800"
          >
            <Close className="!text-2xl !text-black dark:!text-white" />
          </IconButton>
        </span>
      </Box>
    </Modal>
  );
};

export default ImageViwer;
